<template>
  <div>
    <DatePicker
      @on-open-change="openChange"
      @on-clickoutside="clickoutside"
      @on-change="selectDate"
      @on-clear="clear"
      :type="formate || 'date'"
      :clearable="clearable"
      placeholder="选择日期"
      v-model="date"
    ></DatePicker>
  </div>
</template>
<script>
export default {
  props: ["date1", "formate", "clearable"],
  data() {
    return {
      date: "",
    };
  },
  methods: {
    selectDate(v) {
      this.$emit("abc", this.utils.toSjc(this.date));
    },
    openChange(v) {
      /* setTimeout(() => {
        alert(this.utils.time(date));
      }, 500); */
      var date = this.date1;

      if (this.utils.isEmpty(date)) {
        this.date = new Date();
      }

      this.$emit("abc", this.utils.toSjc(this.date));
    },

    clickoutside() {
      var date = this.date;
    },

    clear() {
      //this.$emit("abc", this.utils.toSjc(this.date));
      //console.log(this.date)
      //this.$emit("abc", this.utils.toSjc(this.date));
      //console.log(this.utils.toSjc(this.date));
    },
  },
  mounted() {
    if (this.utils.isEmpty(this.date1)) {
      //this.$emit("abc", "");
    } else {
      this.date = new Date(this.date1);
      //this.$emit("abc", this.utils.toSjc(this.date));
    }

    //
  },
  model: {
    prop: "date1",
    event: "abc",
  },
  watch: {
    date1(v) {
      if (this.utils.isEmpty(v)) {
        this.date = "";
      } else {
        this.date = new Date(v);
      }
    },
    date() {
      this.$emit("abc", this.utils.toSjc(this.date));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/lyyymmdd.vue